var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("UIButton", {
    attrs: {
      disabled: _vm.disabled,
      processing: _vm.processing,
      buttonText: "Delete already read notifications",
      variant: "outline",
    },
    on: { click: _vm.deleteReadNotifications },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }